import axios, { AxiosRequestConfig } from 'axios';

import env from '@/env';
import authService from './index';

const baseURL = env.api.baseUrl.identityService;

const instance = axios.create({
  baseURL,
});

let accessToken: string;

const onRequest = async (request: AxiosRequestConfig) => {
  if (!accessToken) {
    accessToken = await authService.getAppAccessToken();
  }

  request.headers.Authorization = `Bearer ${accessToken}`;
  return request;
};

instance.interceptors.request.use(onRequest);

export default instance;
